export default __webpack_public_path__ + "static/media/38_4_2.17e634a2.png";